import * as Yup from 'yup';

const updateNumberValidation = Yup.object().shape({
  multiply: Yup.number().integer().positive().required(),
  maximum: Yup.number().integer().positive().nullable(true).transform(v => isNaN(v) ? null : v) //Todo: fix this one
});
export default updateNumberValidation;
